// extracted by mini-css-extract-plugin
export default {"container":"Tooltip_container__KoBUE","open":"Tooltip_open__kwjfT"};